import React from 'react'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { DateTime } from 'luxon';
import { ReactComponent as Plus } from "../../assets/new-icons/plus.svg";
import { ReactComponent as Canone } from "../../assets/new-icons/canone.svg";
import { ReactComponent as Incasso } from "../../assets/new-icons/bank2.svg";
import { ReactComponent as Cuore } from "../../assets/new-icons/cuore.svg";
import { ReactComponent as Euro } from "../../assets/new-icons/euro.svg";


function item(props) {
    const { amount, data_emissione, tag, reason  } = props.data
    const setOverlay = props.setOverlay;
    const setDetails = props.setDetails;
    const overlay = props.overlay

    const switchColor = () => {
        switch (tag) {
            case 'ricarica':
                return '#FF7D57'
            case 'consumi':
                return '#19C1FF'
            case 'canone-rai':
                return '#FFD300' 
            case 'incasso-sdd':
                return '#697386'
            default:
                return '#4F29A8';
        }
    }
    const switchIcon = () => {
        switch (tag) {
            case 'ricarica':
                return <Plus />
            case 'canone-rai':
                return <Canone />
            case 'incasso-sdd':
                return <Incasso />
            case 'bonus-sociale':
                return <Cuore />
            case 'ricariche-bonus':
                return <Cuore />
            case 'consumi':
                return <Euro/>
            default:
                break;
        }
    }
    const switchInfo = () => {
        switch (tag) {
            case 'ricarica':
                return 'Ricarica effettuata correttamente';
            case 'canone-rai':
                return 'Pagamento del canone Rai.'
            case 'incasso-sdd':
                return 'Abbiamo incassato dal tuo conto corrente.'
            case 'consumi':
                return ''
        }
    }
    const handleDetails = (i) => {
        setOverlay(!overlay)
        setDetails(i)
    }
    return (
        <div className="movimento" onClick={() => handleDetails(props.data)}>
            <div className="icon">
                <div className="circle">
                    <i style={{backgroundColor: switchColor()}}></i>
                    {switchIcon()}
                </div>
            </div>
            <div className="text">
                <p className="date">{DateTime.fromISO(data_emissione).toFormat("D")}</p>
                <div className="mainPrice">
                    <p className="main">{reason}</p>
                    <p className="price">
                        {amount.toString().includes('-') ? parseFloat(amount).toFixed(2).replace(/\./g, ",") : `+ ${parseFloat(amount).toFixed(2).replace(/\./g, ",")}`} €
                    </p>
                </div>
                <p className="secondary">{switchInfo()}</p>
            </div>
            <div className="arrow">
                <ArrowForwardIosIcon />
            </div>
        </div>
    )
}

export default item